module.exports = __webpack_public_path__ + "img/debate233.14141762.jpg";